import { useEffect, useRef, useState } from 'react';

// Reports when an element first scrolls into view. Stays true afterwards.
const useInView = (options = { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  const { threshold, rootMargin } = options;

  useEffect(() => {
    const node = ref.current;
    if (!node || inView) return undefined;
    if (!('IntersectionObserver' in window)) {
      setInView(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [inView, threshold, rootMargin]);

  return [ref, inView];
};

export default useInView;
